export default "__VITE_ASSET__6aeb6c5c__"